import React from 'react';

import NetWorkIssues from '../../assets/images/Network.gif'
import MyButton from '../../shared-components/button/Button';

/**
 * Handles the submission of a form or an action.
 *
 * This function is triggered when the user submits the form, 
 * and it processes the input values as necessary.
 
 */
const submit = () => {
    const a = true;
    console.log(a);
};
/**
 * NetworkIssue component renders a message indicating a network connectivity problem.
 *
 * This component is displayed when the application encounters a network error,
 * notifying the user of connectivity issues that may be preventing data from loading.
 * @returns {JSX.Element} The rendered component showing a "Network Issue" message.
 */
function NetworkIssue() {
    return (
        <div className="network-issues-error">
            <div className="image-container">
                <img src={NetWorkIssues} alt="" />
            </div>
            <div className="content-container">
                <h3>Oops! Network Issue</h3>
                <p>No Network Connection</p>
                <p>Found Please Check Your</p>
                <p>Connection</p>
                <div className="content-btn">
                    <MyButton label="Take me to home" buttonType="submit" onClickFunc={submit} disableHoverEffect />
                </div>
            </div>
        </div>
    )
}

export default NetworkIssue;